export default "__VITE_ASSET__BMH8vgLE__"